export default __webpack_public_path__ + "static/media/Loader.3fe0288a.gif";